export interface RecuperarUsuario {
    cui: string;
}

export class RecuperarUsuario implements RecuperarUsuario {
    constructor(init?: RecuperarUsuarioFormValues) {
        Object.assign(this, init);
    }
}

export class RecuperarUsuarioFormValues {
    cui: string= "";
    
    constructor(RecuperarUsuario?: RecuperarUsuarioFormValues) {
        if (RecuperarUsuario) {
            this.cui = RecuperarUsuario.cui
        }
    }
}

export interface RecuperarUsuarioRespuesta {
    Id: string;
    Email:string;
    Phone: string
}

export interface CambiarCorreoyContraseña {
    email: string;
    token:string;
    password: string
}

export class CambiarCorreoyContraseña implements CambiarCorreoyContraseña {
    constructor(init?: CambiarCorreoyContraseñaFormValues) {
        Object.assign(this, init);
    }
}

export class CambiarCorreoyContraseñaFormValues {
    email: string= "";
    token:string = "";
    password: string = ""
    
    constructor(CambiarCorreoyContraseña?: CambiarCorreoyContraseñaFormValues) {
        if (CambiarCorreoyContraseña) {
            this.email = CambiarCorreoyContraseña.email
            this.token = CambiarCorreoyContraseña.token
            this.password = CambiarCorreoyContraseña.password
        }
    }
}